export const F2UpsellHeapId = 'F2_Upsell'
